import React, { useState, useEffect } from "react";
import { SelectChangeEvent } from "@mui/material";
import getModalStyle from "../../../../util/getModalStyle";
import { useQueryClient } from "react-query";
import round from "../../../../util/round";
import { postAdminCharge } from "../../../../api/OrderSummaryApi";

function useAdminCostSelector(
  handleClose: () => void,
  charge: string,
  withMargin: boolean | "",
  chargeLabel: string,
  quoteId: string,
  userId: string,
  isFetching: boolean,
  dealerTax?: number
) {
  const queryClient = useQueryClient();

  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const [cost, setCost] = useState({ charge: "", label: "" });

  const [err, setErr] = useState("");

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!charge && !chargeLabel) return;

    setCost({ charge, label: chargeLabel });

    if (typeof withMargin === "boolean") {
      setValue(withMargin ? "Dealer/Customer Price" : "Dealer Price");
    }
  }, []);

  const handleCostChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setCost({ ...cost, [name]: value });
  };

  const handleChange = (event: SelectChangeEvent<string>) =>
    setValue(event.target.value || "");

  const addAdminCost = async () => {
    if(isFetching) return;
    
    if ((!cost.charge && cost.label) || (!cost.label && cost.charge)) {
      return setErr(
        "Please Fill Out Both Fields Or Leave Both Empty to Remove the Charge"
      );
    }

    if (!value && !dealerTax) {
      return setErr("Please make a selection from the dropdown");
    }

    setErr("");
    setLoading(true);

    const response = await postAdminCharge({
      adminCharge: cost.charge ? round(parseFloat(cost.charge)) : 0,
      adminChargeLabel: cost.label,
      withMargin: value === "Dealer/Customer Price" || dealerTax ? true : false,
      quoteId,
      userId
    });

    if (response.data === "Admin Charge Added") {
      queryClient.invalidateQueries("Cart");
      setLoading(false);
      handleClose();
    } else {
      setLoading(false);
      setErr("Error: A Problem Occurred when Adding the Charge");
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      return addAdminCost();
    }
  };

  const preventEnterEffects = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return {
    preventEnterEffects,
    handleKeyDown,
    handleChange,
    handleCostChange,
    loading,
    value,
    err,
    modalStyle,
    cost,
    addAdminCost
  };
}

export default useAdminCostSelector;
